<template>
	<div class="StoreSettings">
		<div class="section1 card">
			<el-row :gutter="20">
				<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
					<p class="lable text-sm">
						Store Name
					</p>
					<el-select v-model="store_name" filterable style="max-width: 350px; min-width: 250px;"
						placeholder="Select Store" :disabled="applicable_to_all && $route.name == 'Activities'"  @change="updateStoreName()">
						<el-option v-for="(item, index) in store_list" :key="index" :value="item.id" :label="item.name">
							{{ item.name }}
						</el-option>
					</el-select>
				</el-col>

				<el-col :xs="1" :sm="1" :md="6" :lg="6" :xl="6">
					<el-checkbox v-if="$route.name == 'Activities'" v-model="applicable_to_all" :disabled="store_name ? true : false"
						class="mt-8">Applicable to all stores</el-checkbox>
					<!-- <p class="lable text-sm">Applicable to all Stores?</p> -->
					<!-- <el-checkbox
						v-model="checked"
						style="display: block;margin-bottom: 20px;height: 40px;width: 200px;"
						:border="true"
						size="medium"
						true-label="all"
						false-label="none"
						@change="
							() => {
								updateStoreName();
							}
						"
					>
						<p v-if="checked == 'all'">
							&nbsp;&nbsp;Yes
						</p>
						<p v-if="checked == 'none'">
							&nbsp;&nbsp;&nbsp;No
						</p>
					</el-checkbox> -->
				</el-col>
				<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
					<!-- <div class="buttons-parrent">
						<div class="button-child">
							<a download>
								<BaseButton
									type="submit"
									style="height: 32px;"
									buttonclass="btn p-2 text-xs"
								>
									Download Store Template
								</BaseButton>
							</a>
						</div>
					</div> -->
				</el-col>

				<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
					<!-- <div class="button-child">
						<div class="if-not my-6">
							<div>
								<label class="btn text-xs py-2 px-12" style="height: 32px;">
									Upload CSV
									<input
										id="articleMaster"
										name="File Upload"
										type="file"
										accept=".csv"
										@change="uploadCSV($event)"
									/>
								</label>
							</div>
						</div>
					</div> -->
				</el-col>
			</el-row>
		</div>

		<div class="section2 card">
			<el-row>
				<el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="font-semibold text-center">
						<span :class="[this.$route.name == 'StoreDetails' ? 'active' : 'tab']"
							@click="changeTab('StoreDetails')">
							Store Details
						</span>
					</p>
				</el-col>
				<el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="font-semibold text-center">
						<span :class="[this.$route.name == 'WorkArea' ? 'active' : 'tab']"
							@click="changeTab('WorkArea')">
							Department
						</span>
					</p>
				</el-col>
				<el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="font-semibold text-center">
						<span :class="[this.$route.name == 'Activities' ? 'active' : 'tab']"
							@click="changeTab('Activities')">
							Activities
						</span>
					</p>
				</el-col>
				<el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="font-semibold text-center">
						<span :class="[this.$route.name == 'Staff' ? 'active' : 'tab']" @click="changeTab('Staff')">
							Guidelines / Policy
						</span>
					</p>
				</el-col>
				<el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="font-semibold text-center">
						<span :class="[this.$route.name == 'Team' ? 'active' : 'tab']" @click="changeTab('Team')">
							Team
						</span>
					</p>
				</el-col>
				<el-col :xs="12" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="font-semibold text-center">
						<span :class="[this.$route.name == 'Target' ? 'active' : 'tab']" @click="changeTab('Target')">
							Target
						</span>
					</p>
				</el-col>
				<!-- <el-col :xs="12" :sm="3" :md="3" :lg="3" :xl="3">
					<p class="font-semibold text-center">
						<span
							:class="[this.$route.name == 'Tasks' ? 'active' : 'tab']"
							@click="changeTab('Tasks')"
						>
							Tasks
						</span>
					</p>
				</el-col> -->
			</el-row>
		</div>
		<div v-if="show_view">
			<router-view />
		</div>
	</div>
</template>

<script>
import LabourPalnningService from "../../../../services/labourPalnningService";
import { mapActions, mapState } from "vuex";
import { EventBus } from "../../../../eventBus";
import { serverAddr } from "../../../../networkConfig";

export default {
	name: "StoreSettings",
	data() {
		return {
			store_list: [],
			SaveStoreList: [],
			store_name: "",
			checked: "none",
			applicable_to_all: false,
			show_view: true
		};
	},

	computed: {
		...mapState("LabourPlanning", ["storeName"]),
		user(){
			return this.$store.state.loginUserDetails;
		}
	},
	mounted() {
		const self = this;
		EventBus.$on('remount_activity', function(data) {
			self.show_view = false;
			setTimeout(() => {
				self.show_view = true;
			}, 1000);
		});
	},
	created() {
		LabourPalnningService.getAllStoreData()
					.then(response => {
						var all_store_list = JSON.parse(response.data);
						this.store_list = all_store_list.filter(el => {
							if (el.type == "store") {
								return el;
							}
						});
						//---------------------------------//
						//     DEFAULT STORE SELECTION     //
						//---------------------------------//
						if (this.store_list.length > 0 || localStorage.getItem('store_id')) {
							if (localStorage.getItem('store_id') && validateStoreId(localStorage.getItem('store_id'))) {
								this.store_name = localStorage.getItem('store_id');
								this.setStoreName(localStorage.getItem('store_id'));
								localStorage.setItem('store_id', this.store_name);
							} else {
								this.store_name = this.store_list[0].id;
								this.setStoreName(this.store_list[0].id);
								localStorage.setItem('store_id', this.store_list[0].id);
							}
						}

						function validateStoreId(store_ID) {
							let store_lists_data = [...all_store_list];
							return store_lists_data.some((s)=> s.id == store_ID)
						}

						// console.log(this.user)
						if (this.user.email == 'rkhan@burgerking.in' || this.user.email == 'vdhanuka@burgerking.in' || this.user.email == 'ukhemka@burgerking.in' || this.user.email == 'ssinha@burgerking.in' || this.user.email == 'ntiwari@burgerking.in') {
							this.store_list = this.store_list.filter(store => {
								if (store.name != "virar dt mumbai" && store.name != "churchgate pre cv cat prep time" && store.name != "dy patil nerul navi mumbai" && store.name != "churchgate express bldg") {
									return store;
								}
							})
						}
						// let selectStore = localStorage.getItem("store");
						if (this.user.access_level == "outlet") {
							// this.selectStore = selectStore;
							this.store_list.filter(
								function (store) {
									if (store.id == this.user.access_outlet) {
										this.store_name = store.id;
									}
								}.bind(this)
							);

							this.setStoreName(this.store_name.toString());

						}
						this.store_list.forEach(el => {
							el.name = `${el.name} ${el.is_test ? "(Test mode)" : ""} `
						})
						this.store_list.sort((a, b) =>
							a.name > b.name ? 1 : b.name > a.name ? -1 : 0
						); // sort a-z store list
						// this.getSavedStore();
					})
					.catch(err => {
						console.error(err);
					}).then(()=>{
						this.getSectionDetailsAction(this.store_name);
						// EventBus.$emit('updatedStoreDetails');
						EventBus.$emit("updateStoreData");
					});
		let store = localStorage.getItem("store_name");
		if (store) {
			this.store_name = store;
			this.setStoreName(this.store_name.toString());
			// EventBus.$emit("updateStoreData");
		}
		if (this.store_name === "") {
			this.setStoreName(this.store_name.toString());
		}
	},
	beforeRouteLeave(to, from, next) {
		localStorage.removeItem("store_name");
		next();
	},
	beforeDestroy() {
		EventBus.$off();
		EventBus.$off("updateStoreData");
	},
	methods: {
		...mapActions("LabourPlanning", ["setStoreName", "getSectionDetailsAction"]),

		updateStoreName() {
			// Load store section data action
			this.getSectionDetailsAction(this.store_name);
			// Set changed store in localStorage
			localStorage.setItem('store_id', this.store_name);
			if (this.checked == "all") {
				this.setStoreName(this.checked.toString());
				EventBus.$emit("updateStoreData");
			} else {
				for (let i = 0; i < this.store_list.length; i++) {
					if (this.store_list[i].id == this.store_name) {
						localStorage.setItem("test_store", this.store_list[i].is_test);
					}
				}
				this.setStoreName(this.store_name.toString());
				localStorage.setItem("store_name", this.store_name);
				EventBus.$emit("updateStoreData");
			}
		},
		changeTab(pathName) {
			if (this.store_name) {
				this.$router.push({ name: pathName }).catch(()=>{});
			} else {
				this.$notify.warning({
					title: "Store not found",
					message: "Please select store name"
				});
			}
		}
		// getSavedStore() {
		// 	LabourPalnningService.getSavedStoreData()
		// 		.then(response => {
		// 			this.SaveStoreList = JSON.parse(response.data);
		// 			if (this.SaveStoreList.length) {
		// 				var tempStoreList = [];
		// 				for (var i in this.store_list) {
		// 					for (var j in this.SaveStoreList) {
		// 						if (this.store_list[i].id == this.SaveStoreList[j]) {
		// 							tempStoreList.push(this.store_list[i]);
		// 						}
		// 					}
		// 				}
		// 				this.store_list = tempStoreList;
		// 			}
		// 		})
		// 		.catch(err => {
		// 			console.log(err);
		// 		});
		// }
	}
};
</script>

<style lang="scss" scoped>
@import "./StoreSettings.scss";
</style>
<style>
.el-select-dropdown__item {
	text-transform: capitalize;
}

.el-select-dropdown__item:first-letter {
	text-transform: uppercase;
}

.StoreSettings .el-input__inner {
	text-transform: capitalize;
}

.StoreSettings .el-dialog {
	width: 60%;
	margin-top: 50px !important;
}

.StoreSettings .el-dialog__header {
	background: #2e323a;
	color: #ffffff;
	padding: 15px;
}

.StoreSettings .el-dialog__title {
	color: #ffffff;
}

@media screen and (max-width: 1120px) {}

::-webkit-scrollbar {
	width: 6px;
}

::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb {
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
</style>
